import { render, staticRenderFns } from "./HowToVideos.vue?vue&type=template&id=21164a34&scoped=true"
import script from "./HowToVideos.vue?vue&type=script&lang=js"
export * from "./HowToVideos.vue?vue&type=script&lang=js"
import style0 from "./HowToVideos.vue?vue&type=style&index=0&id=21164a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21164a34",
  null
  
)

export default component.exports